import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'

import BPPDetailPage from '@/components/pages/guest/_ext-intitutions/containers/details/bpp'

export const Route = createFileRoute(
  '/_guest/guest/extensions-institutions/bpp/$id'
)({
  component: RouteComponent,
  validateSearch: z.object({
    province_code: z.string().optional(),
    city_code: z.string().optional()
  })
})

function RouteComponent() {
  return <BPPDetailPage />
}
